import { TFunction } from "i18next";

export const getActivityColumns = (t: TFunction) => [
  {
    title: t('Analytics.docsActivity.user_name'),
    dataIndex: 'user_name',
    key: 'user_name',
    width: '17%',
  },
  {
    title: t('Analytics.docsActivity.email'),
    dataIndex: 'email',
    key: 'email',
    width: '13%',
  },
  {
    title: t('Analytics.docsActivity.action_cnt'),
    dataIndex: 'action_cnt',
    key: 'action_cnt',
    width: '12%',
    sorter: (a: any, b: any) => Number(a.action_cnt) - Number(b.action_cnt),
  },
  {
    title: t('Analytics.docsActivity.today_action_cnt'),
    dataIndex: 'today_action_cnt',
    key: 'today_action_cnt',
    width: '12%',
    sorter: (a: any, b: any) => Number(a.today_action_cnt) - Number(b.today_action_cnt),
  },
  {
    title: t('Analytics.docsActivity.file_actions_cnt'),
    dataIndex: 'file_actions_cnt',
    key: 'file_actions_cnt',
    width: '12%',
    sorter: (a: any, b: any) => Number(a.file_actions_cnt) - Number(b.file_actions_cnt),
  },
  {
    title: t('Analytics.docsActivity.today_file_actions_cnt'),
    dataIndex: 'today_file_actions_cnt',
    key: 'today_file_actions_cnt',
    width: '12%',
    sorter: (a: any, b: any) => Number(a.today_file_actions_cnt) - Number(b.today_file_actions_cnt),
  },
  {
    title: t('Analytics.docsActivity.last_visit'),
    dataIndex: 'last_visit',
    key: 'last_visit',
    width: '22%',
    sorter: (a: any, b: any) => Number(a.last_visit) - Number(b.last_visit),
  },
];


